import { IServiceInstance, ServiceInstance } from '@module/license/models';
import { requestServiceDelete, requestServicePost, requestServicePut } from '@service/serviceDataService';
import { Option } from 'react-select';

export const SERVERWITHSERVICES_UPDATE_ERROR = 'SERVERWITHSERVICES_UPDATE_ERROR';
export const SERVERWITHSERVICES_UPDATE_SUCCESS = 'SERVERWITHSERVICES_UPDATE_SUCCESS';
export const SERVICE_DELETE_SUCCESS = 'SERVICE_DELETE_SUCCESS';
export const SERVICE_DELETE_ERROR = 'SERVICE_DELETE_ERROR';
export const SERVERWITHSERVICES_ALLOCATION_UPDATE = 'SERVERWITHSERVICES_ALLOCATION_UPDATE';

export function onUpdateServerWithServices(serviceInstance: IServiceInstance, accessToken: string) {
    return (dispatch: any) => {
        makeServerWithServicesPutRequest(dispatch, serviceInstance, accessToken);
    };
}

export function onUpdateServerWithServicesResponseSuccess(serviceInstance: any, isPost: boolean) {
    return {
        type: SERVERWITHSERVICES_UPDATE_SUCCESS,
        newServiceInstance: serviceInstance,
        isPost
    };
}

export function onUpdateServerWithServicesResponseError() {
    return {
        type: SERVERWITHSERVICES_UPDATE_ERROR,
        text: 'Error receiving data'
    };
}

export function onDeleteRow(serviceInstance: IServiceInstance, accessToken: string) {
    return (dispatch: any) => {
        makeServiceDeleteRequest(dispatch, serviceInstance, accessToken);
    };
}

export function onDeleteServiceResponseSuccess(serviceInstance: IServiceInstance) {
    return (dispatch: any) => {
        dispatch({
            type: SERVICE_DELETE_SUCCESS,
            serviceInstance
        });
    };
}

export function onDeleteServiceResponseError() {
    return {
        type: SERVICE_DELETE_ERROR,
        text: 'Error receiving data'
    };
}

export function makeServerWithServicesPutRequest(dispatch: any, serviceInstance: IServiceInstance, accessToken: string) {
    const isPost = serviceInstance.id === -1;
    const serviceInstanceUpdateOrAdd = isPost ? requestServicePost(serviceInstance, accessToken) :
      requestServicePut(serviceInstance, accessToken);
    return serviceInstanceUpdateOrAdd.then(
        (success: any) => {
            dispatch(onUpdateServerWithServicesResponseSuccess(success, isPost));
        },
        (error: any) => {
            dispatch(onUpdateServerWithServicesResponseError());
        }
    );
}

export function onInstanceAllocationEdit(newAllocation: string, serviceInstance: IServiceInstance) {
    return {
        type: SERVERWITHSERVICES_ALLOCATION_UPDATE,
        newAllocation,
        serviceInstance
    };
}

export function makeServiceDeleteRequest(dispatch: any, serviceInstance: IServiceInstance, accessToken: string) {
    return requestServiceDelete(serviceInstance, accessToken).then(
        (success: IServiceInstance) =>
            dispatch(onDeleteServiceResponseSuccess(success)),
        error =>
            dispatch(onDeleteServiceResponseError())
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/license/actionCreators/machineActionCreators.ts